import styled from '@emotion/styled';

export const InvestingBoardTabRoot = styled('div')({
  marginTop: 16,
  flex: 1,
  minHeight: 0,
  display: 'flex',
  flexDirection: 'column',
});
